import React, { useEffect, useState } from "react";

const trackEvent = (eventName, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
};

function Navbar() {
  const [user, setUser] = useState(null);
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    fetch("/current_user", {
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoggedIn(data.logged_in);
        if (data.logged_in) setUser(data.user);
      })
      .catch((error) => console.error("Error fetching current_user:", error));
  }, []);

  const handleLogout = () => {
    trackEvent("sign_out_click", {
      page_path: window.location.pathname,
    });

    fetch("/sign_out", {
      method: "DELETE",
      credentials: "include",
      headers: {
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setLoggedIn(false);
          setUser(null);
          window.location.href = data.redirect_url || "/";
        } else {
          console.error("Logout failed:", data);
        }
      })
      .catch((error) => console.error("Logout error:", error));
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light p-0"
      style={{
        backgroundColor: "#f5f5f5",
        borderBottom: "1px solid #dddddd",
      }}
    >
      <div className="container-fluid px-0">
        <div className="d-flex align-items-stretch">
          <a
            href="https://www.cs2n.org"
            className="d-flex align-items-center text-white text-decoration-none fw-bold px-3"
            style={{
              backgroundColor: "#c41230",
              minHeight: "44px",
            }}
          >
            <img
              src="/cs-stem-logo.png"
              alt="CS-STEM Network"
              height="28"
              className="d-inline-block me-2"
            />
            <span>CS-STEM Network</span>
          </a>

          <a
            href="/"
            className="d-flex align-items-center text-dark text-decoration-none fw-bold px-3"
            style={{
              minHeight: "44px",
            }}
          >
            <span>Games</span>
          </a>
        </div>

        <button
          className="navbar-toggler me-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse pe-3" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-center">
            {loggedIn ? (
              <>
                {user?.admin && (
                  <li className="nav-item">
                    <a className="nav-link text-dark" href="/admin">
                      Admin
                    </a>
                  </li>
                )}

                <li className="nav-item dropdown ms-3">
                  <button
                    className="nav-link dropdown-toggle btn btn-link text-dark text-decoration-none px-0"
                    id="userDropdown"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {user?.username || user?.name || user?.email || "Account"}
                  </button>

                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby="userDropdown"
                  >
                    <li>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Sign Out
                      </button>
                    </li>
                  </ul>
                </li>
              </>
            ) : (
              <li className="nav-item">
                <a
                  className="btn btn-light btn-sm text-dark"
                  href="/sign_in"
                  onClick={() =>
                    trackEvent("sign_in_click", {
                      page_path: window.location.pathname,
                    })
                  }
                >
                  Sign In
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
